export class ActionResult {
    constructor(type, value, error) {
        this.type = type;
        this.value = value;
        this.error = error;
    }
}
//# sourceMappingURL=ActionResult.js.map